
import { Component, Vue, Prop } from 'vue-property-decorator';
  
import StepBase from "../StepBase.vue";
import { stepInfoType } from "@/types/Application";
import ApplicantInfo from "./ApplicantInfo.vue";
import ApplicantCitor from "./citorComponent/ApplicantCitor.vue";
import ApplicantService from "./ApplicantService.vue";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
        StepBase,        
        ApplicantInfo,
        ApplicantCitor,
        ApplicantService
    }
})

export default class ApplicantInfoStep extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;
    
};
